document.addEventListener('DOMContentLoaded', function() {
  const maxChars = 200;

  function waitForElements() {
    return new Promise((resolve) => {
      function checkElements() {
        const form = document.querySelector('form[action="/cart/add"]');
        const recipientForm = document.querySelector('.recipient-form');
        const emailField = document.querySelector('#recipient-email');
        const emailErrorMessage = document.querySelector('#recipient-email-error');
        const firstNameErrorMessage = document.querySelector('#recipient-first-name-error');
        const sendOnField = document.querySelector('#recipient-send-on');
        const sendOnErrorMessage = document.querySelector('#recipient-send-on-error');
        const messageField = document.getElementById('recipient-message');
        const firstNameField = document.getElementById('recipient-first-name');
        const lastNameField = document.getElementById('recipient-last-name');
        const charCount = document.getElementById('char-count');
        const recipientCheckbox = document.getElementById('recipient-checkbox');

        if (form && recipientForm && emailField && emailErrorMessage && firstNameErrorMessage && sendOnField && sendOnErrorMessage && messageField && firstNameField && lastNameField && charCount && recipientCheckbox) {
          resolve({
            form,
            recipientForm,
            emailField,
            emailErrorMessage,
            firstNameErrorMessage,
            sendOnField,
            sendOnErrorMessage,
            messageField,
            firstNameField,
            lastNameField,
            charCount,
            recipientCheckbox
          });
        } else {
          requestAnimationFrame(checkElements);
        }
      }

      checkElements();
    });
  }

  waitForElements().then(elements => {
    const {
      form,
      recipientForm,
      emailField,
      emailErrorMessage,
      firstNameErrorMessage,
      sendOnField,
      sendOnErrorMessage,
      messageField,
      firstNameField,
      lastNameField,
      charCount,
      recipientCheckbox
    } = elements;

    function formatDate(date) {
      const d = new Date(date);
      const month = ('0' + (d.getMonth() + 1)).slice(-2);
      const day = ('0' + d.getDate()).slice(-2);
      const year = d.getFullYear();
      return [year, month, day].join('-');
    }

    function getLosAngelesDate() {
      const losAngelesTimeString = new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" });
      return new Date(losAngelesTimeString);
    }

    const currentDate = getLosAngelesDate();
    const maxDate = new Date(currentDate);
    maxDate.setDate(currentDate.getDate() + 89);

    sendOnField.setAttribute('min', formatDate(currentDate));
    sendOnField.setAttribute('max', formatDate(maxDate));
    sendOnField.setAttribute('placeholder', "yyyy-mm-dd");
    sendOnField.setAttribute('value', formatDate(currentDate));

    function clearHiddenInputs() {
      const existingInputs = form.querySelectorAll('.customer_gift_card input[type="hidden"]');
      existingInputs.forEach(input => input.remove());
    }

    function updateCharCount() {
      const currentLength = messageField.value.length;
      charCount.textContent = `${currentLength}/${maxChars} Characters`;
    }

    updateCharCount();
    messageField.addEventListener('input', updateCharCount);

    function validateField(field, errorMessageElement, validationFn) {
      const isValid = validationFn(field.value);
      if (!isValid) {
        errorMessageElement.classList.remove('hidden');
        field.style.border = '1px solid #FF0000';
      } else {
        errorMessageElement.classList.add('hidden');
        field.style.border = '';
      }
      return isValid;
    }

    function validateEmail(value) {
      return value !== '';
    }

    function validateFirstName(value) {
      return value !== '';
    }

    function validateSendOnDate(value) {
      const sendOnDate = new Date(value);
      const currentDate = getLosAngelesDate();
      const maxDate = new Date(currentDate);
      maxDate.setDate(currentDate.getDate() + 89);
      return !isNaN(sendOnDate.getTime()) && sendOnDate <= maxDate;
    }

    function addOrUpdateInput(name, value) {
      clearHiddenInputs();
      let input = form.querySelector(`input[name="${name}"]`);
      if (input) {
        input.value = value;
      } else {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      }
    }

    function toggleRecipientForm() {
      if (recipientCheckbox.checked) {
        recipientForm.classList.remove('hidden');
      } else {
        recipientForm.classList.add('hidden');
      }
    }

    if (form && recipientForm) {
      recipientCheckbox.addEventListener('change', toggleRecipientForm);
      form.addEventListener('submit', function (e) {
        if (recipientCheckbox.checked) {
          const isEmailValid = validateField(emailField, emailErrorMessage, validateEmail);
          const isFirstNameValid = validateField(firstNameField, firstNameErrorMessage, validateFirstName);
          const isSendOnDateValid = validateField(sendOnField, sendOnErrorMessage, validateSendOnDate);

          if (!(isEmailValid && isFirstNameValid && isSendOnDateValid)) {
            e.preventDefault();
          } else {
            const formattedSendOnDate = formatDate(sendOnField.value);

            addOrUpdateInput('recipient-email', emailField.value);
            addOrUpdateInput('recipient-message', messageField.value);
            addOrUpdateInput('recipient-send-on', formattedSendOnDate);
            addOrUpdateInput('recipient-first-name', firstNameField.value);
            addOrUpdateInput('recipient-last-name', lastNameField.value);
          }
        }
      });

      toggleRecipientForm();
    }
  });
});